import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-personal-info-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './personal-info-profile.html',
  styleUrl: '../../../../employee-details.component.scss',
})
export class PersonalInfoProfileComponent {
  @Input() employeeData: any;
}
